import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/custom.css";
import "./assets/css/moo-sheet.css";
import "./assets/css/kiosk-theme2.css";
import MaterialDashboard from "./material-dashboard";
import setupInterceptors from './services/setupInterceptors';
import eventBus from "vue3-eventbus";
import i18n from "./i18n";
import "material-icons/iconfont/material-icons.css";
import { installCartExpiry, sweepExpiredCarts, watchCartExpiry } from "./config/cartExpiry";

// Before anything reads the cart: drop carts untouched for 24h so they never render.
installCartExpiry();
sweepExpiredCarts();
watchCartExpiry();

const clickOutside = {
    beforeMount: (el, binding) => {
      el.clickOutsideEvent = event => {
        // here I check that click was outside the el and his children
        if (!(el == event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          binding.value();
        }
      };
      document.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted: el => {
      document.removeEventListener("click", el.clickOutsideEvent);
    },
  };

const appInstance = createApp(App);
appInstance.directive("click-outside", clickOutside)
appInstance.use(store);
appInstance.use(router);
appInstance.use(MaterialDashboard);
appInstance.use(eventBus);
appInstance.use(i18n);
setupInterceptors(store);
appInstance.mount("#app");
